export const CONFIRMED_GET_DEFAULT_DOSES = "CONFIRMED_GET_DEFAULT_DOSES";
export const CONFIRMED_CREATE_DEFAULT_DOSE = "CONFIRMED_CREATE_DEFAULT_DOSE";
export const CONFIRMED_DELETE_DEFAULT_DOSE = "CONFIRMED_DELETE_DEFAULT_DOSE";
export const CONFIRMED_EDIT_DEFAULT_DOSE = "CONFIRMED_EDIT_DEFAULT_DOSE";
